import { Box, Heading, Container, useColorMode } from "@chakra-ui/react";
import MainPageStorylaneOverlay from "../MainPageSections/MainPageStorylaneOverlay";
import { getCurrentColor } from "../../constants";

const ShotShowDemoSection = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      bg={getCurrentColor(colorMode, "whiteC.200", "blueC.500")}
      py={{ base: "64px", md: "80px" }}
      borderTop="1px solid"
      borderColor={getCurrentColor(colorMode, "grayC.500", "grayC.2000")}
    >
      <Container maxW="6xl">
        <Heading
          as="h2"
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          fontWeight="700"
          color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
          mb={12}
          textAlign="center"
          lineHeight="tight"
        >
          See It In Action
        </Heading>
        <Box
          borderRadius="lg"
          overflow="hidden"
          border="1px solid"
          borderColor={getCurrentColor(colorMode, "grayC.500", "grayC.2000")}
          bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
        >
          <MainPageStorylaneOverlay />
        </Box>
      </Container>
    </Box>
  );
};

export default ShotShowDemoSection;
